import { opaccLogPlugin, opaccAjaxPlugin } from '../opacc.static.js';

/** @module staticcontent */

/**
 * Statischer Inhalt anzeigen
 *
 */
export class OpaccStaticContent {
	constructor() {
		this.viewportContainer = document.querySelector('.viewport');
		this.requestData = {};
		this.attachEventListener();
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.viewportContainer) {
			this.viewportContainer.addEventListener('click', event => {
				let button = event.target.closest('button.opc-button[data-op-target="#opc-static-content-editor"]');

				if (button) {
					this.sendAjaxRequest(button);
				}
			});
		}
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	sendAjaxRequest(item) {
		this.requestData = {
			type: 'staticcontent',
			boid: item.dataset.opBoid,
			bonumber: item.dataset.opBonumber,
			arttextno: item.dataset.opArttextno,
			langno: item.dataset.opLangno,
			per: item.dataset.opPer,
			template: item.dataset.opAsynctemplate,
			modalid: item.dataset.opTarget
		};
		if(item.dataset.opBo !== undefined){
			this.requestData.bo = item.dataset.opBo;
		}
		if(item.dataset.opAttr !== undefined){
			this.requestData.attr = item.dataset.opAttr;
		}
		if(item.dataset.opId !== undefined){
			this.requestData.id = item.dataset.opId;
		}

        let url = opaccAjaxPlugin.setAsyncUrl(true);

		opaccAjaxPlugin.fetchAsynPostForm(url, this.requestData, this.showContentInEditMode.bind(this), this.getDefaultErrorFnc, true);

	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	async showContentInEditMode(response) {
		if (response.success) {
            opaccLogPlugin.showModal('<img style="display:block;margin:auto" src="data:image/gif;base64,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"/>');
            await import('../../lib/editor/opacc.editor.js');
            const settings = {
                closable: false,
                closableByDimmer: false
            }
            opaccLogPlugin.showModal(response.dataAsHtml, null, true, settings);
			this.initEditor(`${this.requestData.modalid} .edit`);

			// Attach Event-Listener to Save- and Cancel-Button
			let modal = document.querySelector(this.requestData.modalid);
			if (modal) {
				modal.addEventListener('click', event => {
					let btnSave = event.target.closest('button.opc-button[data-op-action="save"]');
					let btnCancel = event.target.closest('button.opc-button[data-op-action="cancel"]');
					if (btnSave) {
						let htmlEncoded = this.htmlEncode(this.getContentFromEditMode());
						this.requestData = {
							type: 'staticcontent',
							boid: btnSave.dataset.opBoid,
							bonumber: btnSave.dataset.opBonumber,
							arttextno: btnSave.dataset.opArttextno,
							langno: btnSave.dataset.opLangno,
							html: htmlEncoded
						};
						if(btnSave.dataset.opBo !== undefined){
							this.requestData.bo = btnSave.dataset.opBo;
						}
						if(btnSave.dataset.opAttr !== undefined){
							this.requestData.attr = btnSave.dataset.opAttr;
						}
						if(btnSave.dataset.opId !== undefined){
							this.requestData.id = btnSave.dataset.opId;
						}

                        // Save WYSIWYG content
                        let url = opaccAjaxPlugin.setAsyncUrl();
						opaccAjaxPlugin.fetchAsynPostForm(url, this.requestData, this.refreshContent.bind(this), this.getDefaultErrorFnc, true);
					}
					if (btnSave || btnCancel) {
						opaccLogPlugin.hideModal();
					}
				});
			}
		}
	}

	/**
	 *
	 *
	 * @returns {*}
	 */
	getContentFromEditMode() {
		// eslint-disable-next-line no-undef
		return opaccEditor.activeEditor.getContent({ format: 'raw' });
	}

	/**
	 *
	 *
	 * @param {*} response
	 */
	refreshContent(response) {
		if (response.success) {
			let contentContainer = document.getElementById(`staticcontent-${this.requestData.boid}-${this.requestData.arttextno}`);
			if(!contentContainer){
				contentContainer = document.getElementById(this.requestData.id);
			}

			if (contentContainer) {
				contentContainer.innerHTML = response.dataAsHtml;
			}
		}
	}

	/**
	 *
	 *
	 * @param {*} selector
	 */
	async initEditor(selector) {
		// Editor must be removed before initialisation
		opaccEditor.remove(selector);
		const opaccEditorUrl = this.getEditorFileUrl();
        const fileTypes = { image: 1, file: 2, media: 3 };

		opaccEditor.init({
			selector: selector,
            language: this.getLanguage(),
            plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image',
                'charmap', 'preview', 'anchor', 'pagebreak', 'searchreplace',
                'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
                'media', 'nonbreaking', 'save', 'table', 'directionality',
                'emoticons', 'quickbars',
            ],
            insertdatetime_formats: ['%d.%m.%Y', '%H:%M'],
            contextmenu: false,
            tools: 'inserttable',
            toolbar:
                'undo redo | styleselect | bold italic | forecolor backcolor | alignleft aligncenter'
                + 'alignright alignjustify | bullist numlist outdent indent | link image media |'
                + 'preview print | removeformat | code',
            width: '100%',
			base_url: `//${opaccEditorUrl.host}${opaccEditorUrl.pathname}/lib/editor/`,
            language_url: `//${opaccEditorUrl.host}${opaccEditorUrl.pathname}/lib/editor/translations/${this.getLanguage()}.js`,
            promotion: false,
            extended_valid_elements: 'i[*]',
            license_key: 'gpl',

			setup: (editor)  => {
				editor.on('SaveContent', (ed) => {
					// Augrund des HTML Encodings durch Aktivieren des application.cnf Parameters 'NoXSSValidation' => htmlEncodeFields()
					// und dem standartmässig eingeschaltetem forced_root_block: <p> beim initialisieren wird der folgende content zuerst
					// nochmals decodiert ( &lt;p&gt; => <p>) und anschliessend encodiert ( <p> => &lt;p&gt; ).
					ed.content = this.htmlEncode(this.htmlDecode(ed.content));
				});
			},
            file_picker_callback: (callback, value, meta) => {
                let type = fileTypes[meta.filetype]
				window.tinymce.activeEditor.windowManager.openUrl({
                    title: 'Fileupload Area',
                    url: this.getFileManagerURL(window.tinymce.activeEditor, type),
                    width: 800,
                    height: 600,
                });
            },
		});
	}

    getFileManagerURL(editor, type) {
        return `/webportal/filemanager.aspx?editor=${editor.id}&type=${type}&lang=${this.getLanguage()}`;
    }

    /**
	 *
	 *
	 * @param {*} content
	 * @returns {*}
	 */
	htmlEncode(content) {
		return content.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}

    /**
     *
     *
     * @param {*} content
     * @returns {*}
     */
    htmlDecode(content) {
        return content.toString().replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&quot;/g, '"').replace(/&amp;/g, '&');
    }

	/**
	 *
	 *
	 * @returns {*}
	 */
	getLanguage() {
		if (location.href.indexOf('/en/') !== -1) {
			return 'en_GB';
		} else if (location.href.indexOf('/fr/') !== -1) {
			return 'fr_FR';
		} else if (location.href.indexOf('/it/') !== -1) {
			return 'it';
		} else {
			return 'de';
		}
	}

    /**
	 *
	 *
	 * @returns {*} URLObject
	 */
	getEditorFileUrl() {
		const editorUrl = import.meta !== undefined ? new URL(import.meta.url) : {};

		if ('pathname' in editorUrl) {
			for (let x = 0; x < 3; x++) {
				editorUrl.pathname = editorUrl.pathname.substring(0, editorUrl.pathname.lastIndexOf("/"));
			}
		} else {
			editorUrl.host = 'cdn.was.local';
			editorUrl.pathname = '/was/dev/src'; //Versionsnummer wird beim Deployment des CDN aus Bamboo-Variable übernommen
		}
		return editorUrl;
	}
}
